// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-color: #04041a;
  --text-color: #bcc2ef;
  --main-color: #ff002f;
}

.ThemeProvider {
  scroll-snap-type: y mandatory;
  height: 100vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
}

.ThemeProvider::-webkit-scrollbar{display: none;}

body {
  background-color: var(--bg-color);
}

section {
  scroll-snap-align: start;
}

.mob {
  display: none;
}

@media (max-width: 998px) {
  .mob {
    display: flex;
    color: var(--text-color);
  }

  .ThemeProvider{
    scroll-snap-type:none;
    height: -moz-fit-content;
    height: fit-content;
    overflow-y: scroll;
    scroll-behavior: smooth;  
  }

  .ThemeProvider::-webkit-scrollbar{display: none;}
  body::-webkit-scrollbar{display: none;}

  .deshk {
    display: none;
  }

  .tim {
    height: -moz-fit-content;
    height: fit-content;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,kCAAkC,aAAa,CAAC;;AAEhD;EACE,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,wBAAmB;IAAnB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA,kCAAkC,aAAa,CAAC;EAChD,wBAAwB,aAAa,CAAC;;EAEtC;IACE,aAAa;EACf;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF","sourcesContent":[":root {\n  --bg-color: #04041a;\n  --text-color: #bcc2ef;\n  --main-color: #ff002f;\n}\n\n.ThemeProvider {\n  scroll-snap-type: y mandatory;\n  height: 100vh;\n  overflow-y: scroll;\n  scroll-behavior: smooth;\n}\n\n.ThemeProvider::-webkit-scrollbar{display: none;}\n\nbody {\n  background-color: var(--bg-color);\n}\n\nsection {\n  scroll-snap-align: start;\n}\n\n.mob {\n  display: none;\n}\n\n@media (max-width: 998px) {\n  .mob {\n    display: flex;\n    color: var(--text-color);\n  }\n\n  .ThemeProvider{\n    scroll-snap-type:none;\n    height: fit-content;\n    overflow-y: scroll;\n    scroll-behavior: smooth;  \n  }\n\n  .ThemeProvider::-webkit-scrollbar{display: none;}\n  body::-webkit-scrollbar{display: none;}\n\n  .deshk {\n    display: none;\n  }\n\n  .tim {\n    height: fit-content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
